import { Button } from "shared/Components/button";
import Modal from "../modal";
import { forwardRef } from "react";

export const ModalCard = forwardRef((props, ref) => {
  const {
    title,
    subTitle,
    buttonLabel,
    data,
    icon,
    isIconLeft = true,
    secondaryIcon,
    isSecondaryIconLeft = true,
    secondaryButtonLabel,
    maxHeight = "max-h-[400px]",
    children,
  } = props || {};

  return (
    <Modal
      extraClass={`${maxHeight} pt-0`}
      headerClass="sticky top-6 left-100 z-50"
      iconPosition="right-0"
      ref={ref}
    >
      <div className="bg-white w-[290px]">
        <div className="flex justify-start flex-col border-b pb-3 sticky top-0 bg-white pt-4 w-[230px]">
          {!!title && (
            <span className="text-lg font-semibold text-gray-900 mb-1">
              {title}
            </span>
          )}
          {!!subTitle && (
            <span className="text-sm font-normal text-gray-600">
              {subTitle}
            </span>
          )}
        </div>
        {children}
        {data?.map((e) => (
          <div key={e?.key} className="flex justify-start flex-col mt-4">
            <span className="text-xs font-normal text-gray-600 mb-1">
              {e?.key}
            </span>
            <span className="text-base font-medium text-gray-900">
              {e?.value}
            </span>
          </div>
        ))}
        {!!buttonLabel && (
          <div className="mt-5 pt-5 border-t">
            <Button
              icon={icon}
              prefix={isIconLeft}
              label={buttonLabel}
              width={"max-[375px]:w-[90%]"}
            />
          </div>
        )}
        {!!secondaryButtonLabel && (
          <div className="mt-6">
            <Button
              icon={secondaryIcon}
              prefix={isSecondaryIconLeft}
              label={secondaryButtonLabel}
              width={"max-[375px]:w-[90%]"}
            />
          </div>
        )}
      </div>
    </Modal>
  );
});
